import loadable from '@loadable/component';
import config from '@wearetla/tla-essentials-tools/config';

const SentryProvider = loadable(() => import('./sentry-provider'));

export const LazySentryProvider = ({ children }) => {
	if (config.sentry?.dsn) {
		return <SentryProvider>{children}</SentryProvider>;
	} else {
		return children;
	}
};

export default LazySentryProvider;
